module.exports = __webpack_public_path__ + "img/icon-scene-2.b17dab9d.png";